// Overgezet uit naslag/server/imports/api/calculations/CookieImpactCalculations.ts.
import { max, round } from '../hulp.js';
import { maxCookies, runningTimePerRound } from './StaticCalculationData.js';
const maxImpactOnProduction = (impactsPerAsset) => Math.min(max(impactsPerAsset) || 0, 40);
const impactPerHour = () => maxCookies / runningTimePerRound;
const impactOnProduction = (impactsPerAsset) => round(maxImpactOnProduction(impactsPerAsset) * impactPerHour());
export const cookieProduction = (impactsPerAsset) => round(maxCookies - impactOnProduction(impactsPerAsset));
